export default {
  namespaced: true,

  state () {
    return {
      visible: false,
      content: {},
      cols: null
    }
  },

  getters: {
    visibility: state => {
      return state.visible
    },
    content: state => {
      return state.content
    },
    cols: state => {
      return state.cols
    }
  },

  mutations: {
    visibility (state, bool) {
      if (typeof bool === 'boolean') {
        state.visible = bool
      }
    },
    set (state, options) {
      state.content = options.content || {}
      state.cols = options.cols || null
    }
  },

  actions: {
    show ({ commit, state }, options) {
      return new Promise(resolve => {
        commit('set', options)
        commit('visibility', true)
        resolve()
      })
    },
    hide ({ commit, state }) {
      return new Promise(resolve => {
        commit('set', {})
        commit('visibility', false)
        resolve()
      })
    },
    freezeDocument ({ state }) {
      /**
       * Should be called from watcher.
       */
      if (state.visible && window.addFreeze) {
        window.addFreeze()
      }
      if (!state.visible && window.removeFreeze) {
        window.removeFreeze()
      }
    }
  }
}
